import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './core/pages/LoginPage/LoginPage';
import HomePage from './core/pages/HomePage/HomePage';
import { ToastContainer } from 'react-toastify';
import { useAuth } from './AuthContext';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const { isAuthenticated, loading } = useAuth();

  // Глобальный перехватчик Escape
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === 'Escape') {
        // Проверяем, есть ли открытые модальные окна.
        // Обычно библиотеки добавляют класс 'modal-open' на body или сами модалки имеют роль 'dialog'
        // CoreUI добавляет класс 'modal-open' на body, когда модалка открыта.
        const isModalOpen = document.body.classList.contains('modal-open') || document.querySelector('.modal.show');

        if (isModalOpen) {
          // Останавливаем немедленное закрытие
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation(); // Важно: останавливает другие обработчики Escape

          // Показываем подтверждение
          // setTimeout нужен, чтобы дать браузеру время обработать остановку события
          setTimeout(() => {
            const confirmed = window.confirm("Вы уверены, что хотите закрыть окно? Несохраненные данные могут быть потеряны.");
            
            if (confirmed) {
              // Если пользователь согласился, нам нужно "продолжить" закрытие.
              // Так как мы остановили стандартное событие, нам нужно найти активную модалку и закрыть её программно.
              // Для CoreUI/Bootstrap это часто клик по кнопке закрытия или вызов метода.
              
              // Попытка 1: Найти кнопку закрытия и нажать её
              const closeButton = document.querySelector('.modal.show .btn-close') || document.querySelector('.modal.show .close');
              if (closeButton) {
                closeButton.click();
              } else {
                // Попытка 2: Симуляция клика по подложке (backdrop), если закрытие по клику разрешено
                const backdrop = document.querySelector('.modal-backdrop');
                if (backdrop) {
                  backdrop.click();
                }
              }
            }
          }, 10);
        }
      }
    };

    // { capture: true } важен, чтобы перехватить событие до того, как оно дойдет до модального окна
    document.addEventListener('keydown', handleEscapeKey, { capture: true });

    return () => {
      document.removeEventListener('keydown', handleEscapeKey, { capture: true });
    };
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Проверка авторизации...</div>
      </div>
    );
  }

  return (
    <>
      <Routes>
        <Route
          path="/login"
          element={
            !isAuthenticated ? <LoginPage /> : <Navigate to="/home" replace />
          }
        />
        <Route
          path="/home"
          element={
            isAuthenticated ? <HomePage /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/"
          element={<Navigate to={isAuthenticated ? "/home" : "/login"} replace />}
        />
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? "/home" : "/login"} replace />}
        />
      </Routes>
      <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;